var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GeneralForm',{attrs:{"jenisJurnal":"bppposting","title":_vm.title,"routeBack":_vm.routeBack,"jurnalUrl":_vm.url,"bppmode":"posting"}})}
var staticRenderFns = []

export { render, staticRenderFns }